import { forwardRef, ReactNode } from "react";

import { Avatar } from "../../../components/atoms/Avatar";
import { BackButton } from "../../../components/atoms/BackButton";
import { Header } from "../../../components/atoms/Header";
import { IconButton } from "../../../components/atoms/IconButton";

interface Props {
  icon: string;
  fallbackIcon?: string;
  name: ReactNode;
  rightComponent?: ReactNode;
  notification?: ReactNode;
  onClickIcon?: () => void;
  onBack?: () => void;
}

/**
 * @param icon
 * @param fallbackIcon
 * @param name
 * @param rightComponent
 * @param onClickIcon
 */
export const ChatRoomHeader = forwardRef<HTMLDivElement, Props>(
  (props, ref) => {
    const {
      icon,
      fallbackIcon,
      name,
      rightComponent,
      notification,
      onClickIcon,
      onBack,
    } = props;

    return (
      <Header ref={ref} tw="max-h-20" notification={notification}>
        <BackButton tw="flex-1" fallbackUrl="/chat_rooms" onBack={onBack} />
        <div tw="flex flex-col items-center flex-[2] truncate">
          {icon && (
            <IconButton
              icon={<Avatar src={icon} fallback={fallbackIcon} size={32} />}
              onClick={onClickIcon}
            />
          )}
          <div tw="font-base text-sm tracking-[-0.43px] mt-[11px] w-full text-center truncate">
            {name}
          </div>
        </div>
        <div tw="flex-1 p-4 flex justify-end">{rightComponent}</div>
      </Header>
    );
  }
);

ChatRoomHeader.displayName = "ChatRoomHeader";
